import { useState } from 'react';
import { Icone } from '../../design/Icone';
import type { NomeDoIcone } from '../../design/Icone';
import type { CartaoDeInsight, IconeDoInsight, TomDoInsight } from '../../paineis';
import { IconeExtra } from './pecasDoPainel';
import './insights-novos.css';

/**
 * O CARTÃO DE INSIGHT — o mesmo no Insights do admin e no início do balconista: a cor diz o tipo
 * (alerta, oportunidade, positivo), o número principal vem grande, as frases trazem os números
 * que provam, "ver a conta" mostra de onde saiu, e o botão leva direto para agir.
 */

const ROTULO_DO_TOM: Record<TomDoInsight, string> = {
  alerta: 'Atenção',
  oportunidade: 'Oportunidade',
  positivo: 'Bom sinal',
  neutro: 'Informação',
};

const ICONE: Record<IconeDoInsight, NomeDoIcone | null> = {
  alta: null,
  baixa: null,
  dinheiro: 'money',
  meta: 'gauge',
  relogio: 'clock',
  trofeu: 'trophy',
  caixa: 'box',
  lupa: 'search',
  escudo: 'shield',
  pessoas: 'users',
  raio: null,
};

function IconeDoCartao({ icone }: { icone: IconeDoInsight }) {
  const nome = ICONE[icone];
  if (nome) return <Icone nome={nome} tamanho={17} traco={1.7} />;
  return (
    <IconeExtra
      nome={icone === 'baixa' ? 'down-t' : icone === 'raio' ? 'bulb' : 'up-t'}
      tamanho={17}
      traco={1.8}
    />
  );
}

export function CartaoInsight({ c }: { c: CartaoDeInsight }) {
  const [conta, setConta] = useState(false);
  const max = Math.max(1, ...(c.serie ?? []).map((x) => Math.abs(x.valor)));
  return (
    <article className={`in-cartao in-${c.tom}`}>
      <header className="in-cabeca">
        <span className="in-icone" aria-hidden="true">
          <IconeDoCartao icone={c.icone} />
        </span>
        <span className="in-tom">{ROTULO_DO_TOM[c.tom]}</span>
      </header>
      <h3 className="in-titulo">{c.titulo}</h3>
      {c.numero && <div className="in-numero">{c.numero}</div>}
      <div className="in-linhas">
        {c.linhas.map((l, i) => (
          <p key={i}>{l}</p>
        ))}
      </div>
      {c.serie && c.serie.length > 1 && (
        <div className="in-serie" aria-label="Comparação">
          {c.serie.map((x) => (
            <div
              key={x.rotulo}
              className="in-serie-item"
              title={`${x.rotulo}: ${x.valor.toLocaleString('pt-BR')}`}
            >
              <span
                className="in-serie-barra"
                style={{ height: `${String(Math.max(6, (Math.abs(x.valor) / max) * 100))}%` }}
              />
              <span className="in-serie-rotulo">{x.rotulo}</span>
            </div>
          ))}
        </div>
      )}
      <footer className="in-pe">
        <button
          type="button"
          className="in-conta"
          onClick={() => setConta((v) => !v)}
          aria-expanded={conta}
        >
          {conta ? 'esconder a conta' : 'ver a conta'}
        </button>
        {c.acao && (
          <a className="in-acao" href={c.acao.link}>
            {c.acao.rotulo}
            <Icone nome="chev-r" tamanho={13} traco={1.8} />
          </a>
        )}
      </footer>
      {conta && <p className="in-calculo">{c.calculo}</p>}
    </article>
  );
}
